import React from 'react'
import { Grid } from '@mui/material'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import { State } from '@hookstate/core'
import IDestination from '~/features/Destination/interfaces/IDestination'
import IVehicleType from '~/features/VehicleType/interfaces/IVehicleType'
import ICircunstance from '~/features/Circunstance/interfaces/ICircunstance'

interface VehicleFiltersProps {
  readonly destinationFinalFilter?: boolean
  readonly typeVehicleFilter?: boolean
  readonly vehicleCiscunstanceFilter?: boolean
  readonly destinationVehicleId: State<IDestination | null>
  readonly vehicleType: State<IVehicleType | null>
  readonly vehicleCiscunstance: State<ICircunstance | null>
  readonly getDestinations: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getVehicleTypes: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getCircunstances: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly translate: (key: string) => string
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: any
}

export default function VehicleFilters({
  destinationFinalFilter,
  typeVehicleFilter,
  vehicleCiscunstanceFilter,
  destinationVehicleId,
  vehicleType,
  vehicleCiscunstance,
  getDestinations,
  getVehicleTypes,
  getCircunstances,
  translate,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: VehicleFiltersProps) {
  return (
    <Grid container>
      {typeVehicleFilter && (
        <Grid item xs={2} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            valueId={vehicleType.get()?.id as string}
            optionsFetch={getVehicleTypes}
            label={translate('Vehicle Type')}
            onValueChange={(value) => vehicleType.set(value)}
            disabled={disableFields}
          />
        </Grid>
      )}
      {vehicleCiscunstanceFilter && (
        <Grid item xs={2} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            valueId={vehicleCiscunstance.get()?.id as string}
            optionsFetch={getCircunstances}
            label={translate('Circunstance')}
            onValueChange={(circunstance) =>
              vehicleCiscunstance.set(circunstance)
            }
            disabled={disableFields}
          />
        </Grid>
      )}
      {destinationFinalFilter && (
        <Grid item xs={2} sx={{ paddingRight: 1 }}>
          <FieldAutocompleteRegistration
            label={translate('Destination')}
            onValueChange={(destination) =>
              destinationVehicleId.set(destination)
            }
            valueId={destinationVehicleId.get()?.id as string}
            optionsFetch={getDestinations}
            disabled={disableFields}
          />
        </Grid>
      )}
      <FilterSelectPeriod
        required
        onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
        onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
        onPeriodChange={(value) => initialPeriod.set(value)}
        period={initialPeriod.get()}
        sxPeriod={{ pl: 0, pt: 0 }}
        sxInitialDate={{ pl: 1, pt: 0 }}
        sxFinalDate={{ pl: 1, pt: 0 }}
      />
    </Grid>
  )
}
